// ** Initial State
const initialState = {
    locationData: [],
    deviceData: [],
    screenData: [],
    adsData: [],
    stateData: [],
    cityData: [],
    cityMoniteringData: [],
    isFetching: false,
    isAdvertiser: JSON.parse(localStorage.getItem('isAdvertiser')) || false,
    selectedFolderName: null,
    activeSubscription: false,
    trialActive: false,
    showSubscriptionModal: false
}

const common = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_LOCATION_LIST':
            return { ...state, locationData: action.payload, isFetching: action.isFetching }
        case 'GET_DEVICE_LIST':
            return { ...state, deviceData: action.payload, isFetching: action.isFetching }
        case 'GET_ADS_LIST':
            return { ...state, adsData: action.payload, isFetching: action.isFetching }
        case 'GET_SCREEN_LIST':
            return { ...state, screenData: action.payload, isFetching: action.isFetching }
        case 'GET_STATES_LIST':
            return { ...state, stateData: action.payload, isFetching: action.isFetching }
        case 'GET_CITIES_LIST':
            return { ...state, cityData: action.payload, isFetching: action.isFetching }
        case 'GET_CITIES_MONITERING_LIST':
            return { ...state, cityMoniteringData: action.payload, isFetching: action.isFetching }
        case 'SET_ROLE_ADVERTISER':
            return { ...state, isAdvertiser: action.payload }
        case 'SET_SELECTED_FOLDER_NAME':
            return { ...state, selectedFolderName: action.payload }
        case 'SET_ACTIVE_SUBSCRIPTION':
            return { ...state, activeSubscription: action.payload }
        case 'SHOW_SUBSCRIPTION_MODAL':
            return { ...state, showSubscriptionModal: action.payload }
        case 'SET_TRIAL_ACTIVE':
            return { ...state, trialActive: action.payload }            

        case 'RESET_COMMON_STATE':
            return {
                ...initialState,
                isAdvertiser: false
            }
        default:
            // return { ...state }
            return state

    }
}

export default common